import top10 from './Top10Reducer';

export default top10;
